import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {EditorsComponent} from '@irb/irb-editors/irb-editors.com';
import {IPortfolioResultResponse} from '@irb/irb-editors/editor-portfolio-result/editor-portfolio-result.model';
import {AppService} from '@irb/app.service';
import {IrbDialogsEvents} from '@irb/irb-dialogs/irb-dialogs.events';
import {RebalanceService} from '@irb/irb-editors/rebalance/rebalance.service';

@Component({ standalone: false,
  selector: 'irb-com-pr-info-banner',
  templateUrl: './com-pr-info-banner.component.html',
  styleUrls: ['./com-pr-info-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class ComPrInfoBannerComponent implements EditorsComponent<IPortfolioResultResponse>, OnInit {

  _data: IPortfolioResultResponse;
  @Output() change = new EventEmitter<boolean>();
  hasExplanation: boolean;

  constructor(private appService: AppService, private rs: RebalanceService) { }
  
  ngOnInit() {
    const a = (this.data.rebalAccReportList) ? (this.data.rebalAccReportList.length > 0) : false;
    const b = (this.data.rebalSecReportList) ? (this.data.rebalSecReportList.length > 0) : false;
    this.hasExplanation = a || b;
  }

  @Input()
  get data(): IPortfolioResultResponse {
    return this._data;
  }

  set data(d: IPortfolioResultResponse) {
    this._data = d;
  }

  showExplanation() {
    this.appService.fireEvent(IrbDialogsEvents.SHOW_PR_EXPLANATION, {
      portfolioName: this.data.portfolioName,
      rebalAccReportList: this.data.rebalAccReportList || [],
      rebalSecReportList: this.data.rebalSecReportList || []
    });
  }


  viewRebalance() {
    const params = {
      fullscreen: true,
      data: {
        analysisType: this.data.rebalType,
        analysisId: this.data.rebalId,
        source: "viewResultSummary",
        slot: 'B'
      }
     
    };
    this.rs.getRebalanceTypeEvent(params);
  }
}
